/* Shared 1097/1376 mobile beam touch target. Native input remains keyboard accessible. */
(() => {
  'use strict';
  if (window.__sfBeamTouchArea) return;
  window.__sfBeamTouchArea = true;
  const media = matchMedia('(max-width: 899px)');
  const mounted = new Map();
  function mount(wrap) {
    if (mounted.has(wrap)) return;
    const input = wrap.querySelector('input[type="range"][data-sf-zoom-range]');
    if (!input) return;
    const controller = new AbortController();
    const options = {signal: controller.signal};
    let gesture = null;
    wrap.classList.add('sf-beam-touch-area');
    function setValue(x) {
      if (input.disabled) return;
      const rect = input.getBoundingClientRect();
      // Native thumb center travels from half a thumb width to width - half a thumb width.
      const halfThumb = 11;
      const min = Number(input.min || 0), max = Number(input.max || 100);
      const step = input.step === 'any' ? 0 : Number(input.step || 1);
      const fraction = Math.max(0, Math.min(1, (x - rect.left - halfThumb) / Math.max(1, rect.width - halfThumb * 2)));
      let value = min + fraction * (max - min);
      if (step) value = min + Math.round((value - min) / step) * step;
      input.value = String(Math.max(min, Math.min(max, value)));
      input.dispatchEvent(new Event('input', {bubbles: true}));
    }
    wrap.addEventListener('pointerdown', event => {
      if (!media.matches || input.disabled || !event.isPrimary || event.button !== 0) return;
      gesture = {id: event.pointerId, x: event.clientX, y: event.clientY, axis: null, value: input.value};
      wrap.setPointerCapture(event.pointerId);
    }, options);
    wrap.addEventListener('pointermove', event => {
      if (!gesture || event.pointerId !== gesture.id) return;
      if (!media.matches) { gesture = null; return; }
      const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
      if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) >= 8) {
        gesture.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (gesture.axis === 'x') {
        if (event.cancelable) event.preventDefault();
        setValue(event.clientX);
      }
    }, {...options, passive: false});
    wrap.addEventListener('pointerup', event => {
      if (!gesture || event.pointerId !== gesture.id) return;
      if (media.matches && gesture.axis !== 'y') {
        setValue(event.clientX);
        if (gesture.value !== input.value) input.dispatchEvent(new Event('change', {bubbles: true}));
      }
      gesture = null;
      if (wrap.hasPointerCapture(event.pointerId)) wrap.releasePointerCapture(event.pointerId);
    }, options);
    const cancel = () => { gesture = null; };
    wrap.addEventListener('pointercancel', cancel, options);
    wrap.addEventListener('lostpointercapture', cancel, options);
    // The wrapping <label> would otherwise send a second synthetic click to the input.
    wrap.addEventListener('click', event => { if (media.matches && event.detail !== 0) event.preventDefault(); }, options);
    mounted.set(wrap, controller);
  }
  function scan() {
    for (const [wrap, controller] of mounted) if (!wrap.isConnected) {controller.abort(); mounted.delete(wrap);}
    document.querySelectorAll('.sf-beam-explorer__range-wrap').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once: true});
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(scan));
})();
